export default function (m1, m2) {
  if (m1.date.isBefore(m2.date)) {
    return 1;
  } else if (m1.date.isAfter(m2.date)) {
    return -1;
  }

  return m1.notificationId > m2.notificationId ? -1 : 1;
}
